import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { DocumentStatus } from '@icc/b2b/shared';

@Component({
    selector: 'icc-document-status',
    templateUrl: './document-status.component.html',
    styles: [':host { display: inline-block; }'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentStatusComponent {
    @Input() status: DocumentStatus;
}
